import NextImageView from '@/components/ui/NextImageView/NextImageView';
import { getImageLayoutSizes } from '@/utils/nextImage';
import styles from './UserDesignCard.module.scss';

type UserDesignCardProps = {
  previewImageUrl: string;
  workName: string;
  onClick?: () => void;
  sizes?: string;
};

function UserDesignCard({ previewImageUrl, workName, onClick, sizes }: UserDesignCardProps) {
  const imageSizes = sizes ?? getImageLayoutSizes({ sp: '33vw', pc: '160px' });

  return (
    <div className={styles.card}>
      <button type='button' className={styles.imageContainer} onClick={onClick}>
        <NextImageView src={previewImageUrl} alt={workName} fill objectFit='contain' sizes={imageSizes} />
      </button>
      <p className={styles.workName}>{workName}</p>
    </div>
  );
}

export default UserDesignCard;
